import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MessageCircle, BookOpen, User, Shield } from 'lucide-react';

interface BottomNavBarProps {
  isAuthenticated: boolean;
  isAdmin?: boolean;
}

const BottomNavBar: React.FC<BottomNavBarProps> = ({ isAuthenticated, isAdmin }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const handleNavigation = (path: string) => {
    if (isAuthenticated) {
      if (path === '/dashboard' || path === '/reflections') {
        navigate('/dashboard');
        return;
      }
      if (path === '/profile' || path === '/welcome-back') {
        navigate('/profile');
        return;
      }
    } else {
      if (path === '/dashboard') {
        navigate('/reflections');
        return;
      }
      if (path === '/profile') {
        navigate('/welcome-back');
        return;
      }
    }
    navigate(path);
  };

  const tabs = [
    {
      path: '/chat',
      icon: MessageCircle,
      label: 'Chat',
    },
    {
      path: '/dashboard',
      icon: BookOpen,
      label: 'Reflections',
    },
    {
      path: '/profile',
      icon: User,
      label: 'Profile',
    },
    ...(isAdmin ? [{
      path: '/admin',
      icon: Shield,
      label: 'Admin',
    }] : []),
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-lg border-t border-gray-100 z-50">
      <div className="max-w-lg mx-auto flex justify-around items-center px-6 py-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))]">
        {tabs.map(({ path, icon: Icon, label }) => (
          <button
            key={path}
            onClick={() => handleNavigation(path)}
            className={`flex flex-col items-center p-2 transition-colors ${
              isActive(path)
                ? 'text-purple-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <Icon className={`h-6 w-6 transition-all ${isActive(path) ? 'scale-110' : ''}`} />
            <span className={`text-xs mt-1 font-medium ${isActive(path) ? 'opacity-100' : 'opacity-70'}`}>
              {label}
            </span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNavBar;